import { AfterViewChecked, Component, ElementRef, EventEmitter, Input, Output, ViewChild } from '@angular/core';

export interface MensagemIa {
  papel: 'usuario' | 'assistente';
  texto: string;
  avisos?: string[];
  erros?: string[];
  rodape?: string;
}

@Component({
  selector: 'habil-conversa-ia',
  templateUrl: './conversa-ia.component.html',
  styleUrls: ['./conversa-ia.component.scss'],
})
export class ConversaIaComponent implements AfterViewChecked {
  @Input() mensagens: MensagemIa[] = [];
  @Input() ocupado = false;
  @Input() placeholder = '';
  @Input() rotuloCampo = 'Pedido';
  @Input() vazio = '';
  @Output() enviar = new EventEmitter<string>();

  @ViewChild('lista') lista: ElementRef<HTMLDivElement>;

  texto = '';
  private quantidadeVista = 0;

  ngAfterViewChecked(): void {
    const total = this.mensagens.length + (this.ocupado ? 1 : 0);
    if (total !== this.quantidadeVista && this.lista) {
      this.quantidadeVista = total;
      this.lista.nativeElement.scrollTop = this.lista.nativeElement.scrollHeight;
    }
  }

  mandar(): void {
    const texto = this.texto.trim();
    if (!texto || this.ocupado) {
      return;
    }
    this.enviar.emit(texto);
    this.texto = '';
  }

  tecla(evento: KeyboardEvent): void {
    if (evento.key === 'Enter' && (evento.ctrlKey || evento.metaKey)) {
      evento.preventDefault();
      this.mandar();
    }
  }
}
